import { Component, OnInit, ViewChild } from '@angular/core';
import { InstallmentService } from '../../services/installment.service';

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexPlotOptions,
  ApexLegend,
  ApexTooltip,
} from 'ng-apexcharts';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { ContractService } from '../../services/contract.service';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  title: ApexTitleSubtitle;
  responsive: ApexResponsive[];
  dataLabels: ApexDataLabels;
  labels: any;
  colors: any;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  tooltip: ApexTooltip;
};

@Component({
  selector: 'app-rents-pie-chart',
  templateUrl: './rents-pie-chart.component.html',
  styleUrls: ['./rents-pie-chart.component.css'],
})
export class RentsPieChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  isLoaded: boolean = false;
  isEmpty: boolean = false;

  iconQuestion = faQuestionCircle;

  constructor(private installmentService: InstallmentService) {
    this.installmentService.getInstallmentsQuantity().subscribe(
      (result: any) => {
        let string =
          result.owedInstallments != 0
            ? `(Pagos Parciales) ${result.owedInstallments}`
            : '';
        this.chartOptions = {
          title: {
            align: 'left',
            margin: 0,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize: '0rem',
              fontWeight: 'bold',
            },
          },
          series: [
            result.paidInstallments,
            result.unpaidInstallments + result.owedInstallments,
          ],
          colors: ['#3b82f6', '#f97316'],
          chart: {
            offsetX: 0,
            width: '100%',
            height: 240,
            type: 'donut',
          },
          labels: [
            `Cuotas Cobradas: ${result.paidInstallments}`,
            `Cuotas Adeudadas: ${
              result.unpaidInstallments + result.owedInstallments
            }  ${string}`,
          ],
          responsive: [
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 220,
                },
                legend: {
                  position: 'bottom',
                  fontSize: '12px',
                },
              },
            },
            {
              breakpoint: 1024,
              options: {
                chart: {
                  height: 200,
                },
                legend: {
                  position: 'bottom',
                  fontSize: '11px',
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size: '55%',
                    },
                  },
                },
              },
            },
            {
              breakpoint: 768,
              options: {
                chart: {
                  height: 180,
                },
                legend: {
                  position: 'bottom',
                  fontSize: '10px',
                  itemMargin: {
                    horizontal: 5,
                    vertical: 3,
                  },
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size: '60%',
                      labels: {
                        total: {
                          fontSize: '1.2rem',
                        },
                        value: {
                          fontSize: '0.9rem',
                        },
                      },
                    },
                  },
                },
              },
            },
            {
              breakpoint: 480,
              options: {
                chart: {
                  height: 160,
                },
                legend: {
                  position: 'bottom',
                  fontSize: '9px',
                  itemMargin: {
                    horizontal: 3,
                    vertical: 2,
                  },
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size: '65%',
                      labels: {
                        total: {
                          fontSize: '1rem',
                        },
                        value: {
                          fontSize: '0.8rem',
                        },
                      },
                    },
                  },
                },
              },
            },
          ],
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                size: '50%', // Más grueso: reducido de 70% a 50% (el anillo ocupa más espacio)
                labels: {
                  show: true,
                  total: {
                    show: true,
                    showAlways: true,
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: '#2d3748',
                  },
                  value: {
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#4a5568',
                  },
                },
              },
            },
          },
          legend: {
            formatter: function (label, opts) {
              return label;
            },
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '11px',
            fontWeight: 500,
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return ''
              },
              title: {
                formatter: function (seriesName) {
                  return seriesName
                }
              }
            }
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '13px',
              fontWeight: 'bold',
            },
            dropShadow: {
              enabled: false,
            },
          },
        };
        this.isLoaded = true;
      },
      (error) => {
        if (error.status == 404) {
          this.isLoaded = true;
          this.isEmpty = true;
        }
      },
    );
  }

  ngOnInit() {}
}
